export default __webpack_public_path__ + "static/media/set3.69704f3c.jpeg";